import { EMPTY, map, Observable, tap } from 'rxjs';
import { signal, Signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';
import { crmValidateForm } from '@touch4it/ng-swp/form';

import { CardExtraHandler } from '~/shared/components/card-extra/card-extra.handler';

export abstract class DetailHandler<FormData, Data, Result = Data> implements CardExtraHandler<Result> {
  readonly mode = signal<'read' | 'edit'>('read' as const);
  readonly isEditing$ = toObservable(this.mode).pipe(map((mode) => mode === 'edit'));

  private form?: FormGroup;

  constructor(
    readonly data: Signal<Data>,
    private onUpdate: (data: Result) => void,
    private onReset: () => void,
  ) {}

  save(): Observable<Result> {
    if (!this.form) {
      return EMPTY;
    }

    if (this.form.invalid) {
      crmValidateForm(this.form);
      return EMPTY;
    }

    return this.createSaveRequest(this.form.getRawValue() as FormData).pipe(
      tap((data) => {
        this.mode.set('read');
        this.onUpdate(data);
      }),
    );
  }

  reset(): void {
    this.mode.set('read');
    this.onReset();
  }

  setForm(form: FormGroup) {
    this.form = form;
  }

  getForm() {
    return this.form;
  }

  abstract createSaveRequest(data: FormData): Observable<Result>;
}
